const FACTOR = 2;

function isAvailableRetinaImage(image, desiredSize, useBackEndSize) {
  const {
    imagePattern: src,
    width: originalWidth,
    height: originalHeight,
  } = image;


  const {
    width: desiredWidth,
    height: desiredHeight,
  } = getImageSize(image, desiredSize, useBackEndSize);

  if (!src || !originalWidth || !originalHeight || !desiredWidth || !desiredHeight) {
    return false;
  }

  return originalWidth >= desiredWidth * FACTOR &&
    originalHeight >= desiredHeight * FACTOR;
}

function getImageSize(image, desiredSize, useBackEndSize) {
  //@todo useBackEndSize deleted
  return false
    ? {
      width: image.width,
      height: image.height,
    }
    : desiredSize;
}

function processImageSrc(image, desiredSize) {
  const {
    src,
    size
  } = image;

  const {
    width,
    height,
  } = size;

  if (!width || !height) {
    return src;
  }

  let processedSrc = src;
  const imageSizeString = `${width}-${height}`;

  if (src.indexOf('productimages') > -1) {
    if (src.indexOf('#imgSize') > -1) {
      processedSrc = src.replace('#imgSize', imageSizeString);
    } else if (src.indexOf('{size}') > -1) {
      processedSrc = src.replace('{size}', imageSizeString);
    }
  } else if (src.indexOf('dali-banner') > -1) {
    if (src.indexOf('#imgSize') > -1) {
      processedSrc = src.replace('#imgSize', imageSizeString);
    } else if (src.indexOf('{size}') > -1) {
      processedSrc = src.replace('{size}', imageSizeString);
    }
  } else if (src.indexOf('images') > -1) {
    if (src.indexOf('#imgSize') > -1) {
      processedSrc = src.replace('#imgSize', imageSizeString);
    } else if (src.indexOf('{size}') > -1) {
      processedSrc = src.replace('{size}', imageSizeString);
    }
  } else {
    if (src.indexOf('#imgSize') > -1) {
      processedSrc = src.replace('#imgSize', '135');
    } else if (src.indexOf('{size}') > -1) {
      processedSrc = src.replace('{size}', '135');
    } else {
      processedSrc = src;
    }
  }

  return processedSrc;
}

function generateImageSrc(image, desiredSize, useBackEndSize) {
  const {
    imagePattern: src,
  } = image;

  if (!src) {
    return '';
  }

  return processImageSrc({
    src,
    size: getImageSize(image, desiredSize, useBackEndSize),
    },
    desiredSize
  );
}


function processImageSrcSet(image) {
  const {
    src,
    size
  } = image;

  const {
    width,
    height,
  } = size;

  if (!width || !height) {
    return src;
  }

  let retinaImageUrl;
  const imageSizeString = typeof height == 'undefined' ? `${width * FACTOR}` : `${width * FACTOR}-${height * FACTOR}`;

  if (src.indexOf('productimages') > -1) {
    if (src.indexOf('#imgSize') > -1) {
      retinaImageUrl = src.replace('#imgSize', imageSizeString);
    } else if (src.indexOf('{size}') > -1) {
      retinaImageUrl = src.replace('{size}', imageSizeString);
    }
  } else if (src.indexOf('dali-banner') > -1) {
    if (src.indexOf('#imgSize') > -1) {
      retinaImageUrl = src.replace('#imgSize', imageSizeString);
    } else if (src.indexOf('{size}') > -1) {
      retinaImageUrl = src.replace('{size}', imageSizeString);
    }
  } else if (src.indexOf('images') > -1) {
    if (src.indexOf('#imgSize') > -1) {
      retinaImageUrl = src.replace('#imgSize', imageSizeString);
    } else if (src.indexOf('{size}') > -1) {
      retinaImageUrl = src.replace('{size}', imageSizeString);
    }
  } else {
    if (src.indexOf('#imgSize') > -1) {
      retinaImageUrl = src.replace('#imgSize', '135');
    } else if (src.indexOf('{size}') > -1) {
      retinaImageUrl = stripColor.replace('{size}', '135');
    }
  }

  return retinaImageUrl;
}

function generateImageSrcSet(image, desiredSize, useBackEndSize) {
  const {
    imagePattern: src,
    width: originalWidth,
    height: originalHeight,
  } = image;

  if (!src || !originalWidth || !originalHeight) {
    return '';
  }

  if (!isAvailableRetinaImage(image, desiredSize, useBackEndSize)) {
    return null;
  }

  return {
    png1x: generateImageSrc(image, desiredSize, useBackEndSize),
    png2x: processImageSrcSet({
      src,
      size: getImageSize(image, desiredSize, useBackEndSize),
    })
  };

}

function generateImgSrcSetString(image, desiredSize, useBackEndSize) {
  const imageSrcSet = generateImageSrcSet(image, desiredSize, useBackEndSize);

  if (!imageSrcSet) {
    return '';
  }

  let srcSetString = '';
  if (imageSrcSet.png1x) {
    srcSetString += `${imageSrcSet.png1x} 1x, `;
  }
  if (imageSrcSet.png2x) {
    srcSetString += `${imageSrcSet.png2x} 2x`;
  }

  return srcSetString;
}

export {
  generateImageSrc,
  generateImgSrcSetString,
}



// WEBPACK FOOTER //
// ./src/utils/imageUtils.js